import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { sendComscoreBeacon } from '@/libs/comscore';

export const useComscorePageView = (pageData) => {
  const location = useLocation();

  useEffect(() => {
    // 페이지 이동 시 PV 전송
    sendComscoreBeacon({
      name: pageData?.pageType, // Page Type
      c3: pageData?.siteSection, // Site Section
      c6: pageData?.language || 'ko', // Language
    });
  }, [location.pathname, pageData]);
};
